module.exports = __webpack_public_path__ + "img/fireworks.435c6244.png";